//import cloneDeep from 'lodash/cloneDeep';
// import _ from 'lodash';

import React, { useContext, useState, useEffect } from 'react'
import { useStyles } from "../hooks/useStyles";
import { usePhrasing } from "../hooks/useSkuUtils";
import { useOrderItemChangeHandlers } from "../hooks/useUtils";
import { ShopperContext } from '../context/shopper';
import { useTranslation } from "react-i18next";
import styles from '../css/trTdFirstChild.module.css';
import Table from 'react-bootstrap/Table';
import * as Constants from '../constants'
import HeadingBuilder from './HeadingBuilder';
import OthersOrdersTable from './OthersOrdersTable';
import InputDynamicText from './InputDynamicText';

export const OrderItemTable = ({
  handleClick,
  orderData,
  headings,
  order,
  actualWeight,
  trip,
  sku,
  skuPrice,
  othData,
  tsw,
  if_shopper_is_circle_admin,
    }) => {
  const { signedIn, shopper,
          showOutlayWithTax,
          toggleShowOutlayWithTax,
          showOthersOrders,
        } = useContext(ShopperContext);

  const { tableShow, tableData, verticalOiBorderTopColor,
          textAlignLeft,
          textAlignRight,
            } = useStyles();

  const { t } = useTranslation();
  const {
    shopListNameLabelHeading,
    getNameColComment,
    shopListUnitCountHeading,
    shopListUnitQtyHeading,
    shopListUnitCostHeading,
    shopListWantdHeading,
    shopListRangeNoteHeading,
    shopListOutlayHeading,
    shopListOColHeading,
    orderItemNameLabelContent,
    getUnitCountColHeaderTippyContent,
    getUnitCountColHeaderAudioTippyContent,
    getWeightString,
  } = usePhrasing();
  const { handleMinMaxNoteClick } = useOrderItemChangeHandlers();

  const isSingular =  sku.type === 'SingularItem';
  const isWeighty  =  sku.type === 'WeightyItem';
  const weightStringGotten = getWeightString({sku, actualWeight});
  const dashWeightStringGotten = ` - ${weightStringGotten}`;

  if (signedIn) {

    return (
    <>
      <hr style={verticalOiBorderTopColor} />
      <HeadingBuilder
        headingText    = {t('ordersList.verticalTableButton.labelClose')}
        // Minimize 'Order Item' details
        buttonAction   = {handleClick}
        goButtonText   = {Constants.GET_ICON_RT_ARROW}

        tippyAlertText = {t('ordersList.verticalTableButton.tippyContent')}
        tippyText      = {Constants.DOT}
      />
      <Table responsive striped bordered hover size="sm" style={tableShow}>
        <thead>
        </thead>
        <tbody className={styles.trTdFC} style={tableData} >
          <tr>
            <td>
              {headings.identifierV}
            </td>
            <td>
              {orderData.identifierV}
            </td>
          </tr>
          <tr>
            <td>
              {headings.brand}
            </td>
            <td>
              {orderData.brand}
            </td>
          </tr>
          <tr>
            <td>
              {shopListNameLabelHeading({
                containerTypeNameLabel: 'container-hug-bottom-right',
                tippyAlertTextNameLabel: getNameColComment({
                                           weightString: weightStringGotten,
                                         })
              })}
            </td>
            <td>
              {orderItemNameLabelContent({
                sku, tsw, showSlimShopList: true,
                showUnitCount: false,
                showQtyUnits:  false,
              })}
            </td>
          </tr>
          <tr>
            <td>
              {headings.storeLabel}
            </td>
            <td>
              {orderData.storeLabel}
            </td>
          </tr>
          <tr>
            <td>
              {/* Unit Count -or- Typical Weight */}
              {shopListUnitCountHeading({
                isWeighty: isWeighty,
                containerTypeUnitCount: 'container-hug-bottom-right',
                tippyAlertTextUc: getUnitCountColHeaderTippyContent({
                  shopper,
                  isWeighty,
                  weightString: weightStringGotten,
                }),
                tippyAlertAudioUc: getUnitCountColHeaderAudioTippyContent({
                  shopper,
                  isWeighty,
                  weightString: weightStringGotten,
                }),
              })}
            </td>
            <td>
              {orderData.unitCount}
            </td>
          </tr>
          <tr>
            <td>
              {headings.price}
            </td>
            <td>
              {orderData.price}
            </td>
          </tr>
      {isWeighty
        ? null
        : <tr>
            <td>
              {/* Unit Cost */}
              {shopListUnitCostHeading({})}
            </td>
            <td>
              {orderData.unitCost}
            </td>
          </tr>
      }
    {showOthersOrders
    ? null
    : <>
      {isSingular
        ? null
        : <tr>
            <td>
              {/* Unit Qty */}
              {shopListUnitQtyHeading({
                isForVerticalTable: true,
                sku: sku,
                containerTypeUnitQty: 'container-hug-bottom-right',
              })}
            </td>
            <td>
              {orderData.unitQty}
            </td>
          </tr>
      }
          <tr>
            <td>
              {/* %Wantd */}
              {shopListWantdHeading({
                isForVerticalTable: true,
                sku: sku,
                weightString: dashWeightStringGotten,
              })}
            </td>
            <td>
              {orderData.wantd}
            </td>
          </tr>
          <tr>
            <td>
              {/*  #-#  */}
              {shopListRangeNoteHeading({
                isForVerticalTable: true,
              })}
            </td>
            <td>
              <InputDynamicText
                initialText = {order.min_max_note || ''}
                handleTextClick = {handleMinMaxNoteClick(order.id)}
                rows = {4}
                cols = {32}
                checkboxPosition = "side"
              />
            </td>
          </tr>
          <tr>
            <td>
              {/* Outlay */}
              {shopListOutlayHeading({
                buttonActionOutlay:  toggleShowOutlayWithTax,
                showOutlayWithTax:   showOutlayWithTax,
                containerTypeOutlay: 'container-hug-bottom-right',
              })}
            </td>
            <td>
             <div className = "oneline-container-left">
              {orderData.outlay}
             </div>
            </td>
          </tr>
      </>
    }
          <tr>
            <td>
              {/* 'O' button */}
              {shopListOColHeading({
                containerTypeO: 'container-hug-bottom-right',
              })}
            </td>
            <td>
              {orderData.o}
            </td>
          </tr>
          <tr>
            <td>
              {headings.circleAmt}
            </td>
            <td>
              {orderData.circleAmt}
            </td>
          </tr>
          <tr>
            <td>
              {headings.circleMoney}
            </td>
            <td>
              {orderData.circleMoney}
            </td>
          </tr>
        </tbody>
      </Table>

  { showOthersOrders
    ? <Table responsive striped bordered hover size="sm" style={tableShow}>
        <thead className={styles.trTdFC} style={tableData} >
          <tr>
            <th>
              {/* Who */}
              {headings.shortname}
            </th>
        { isSingular
          ? null
          : <th style={textAlignLeft}>
              {/* Unit Qty */}
              {shopListUnitQtyHeading({
                sku: sku,
                containerTypeUnitQty: 'container-hug-bottom-left',
              })}
            </th>
        }
            <th>
              {/* %Wantd */}
              {shopListWantdHeading({
                sku: sku,
                weightString: dashWeightStringGotten,
              })}
            </th>
            <th>
              {/*  #-#  */}
              {shopListRangeNoteHeading({
                isForVerticalTable: false,
              })}
            </th>
            <th>
              {/* Outlay */}
              {shopListOutlayHeading({
                buttonActionOutlay:  toggleShowOutlayWithTax,
                showOutlayWithTax:   showOutlayWithTax,
                containerTypeOutlay: 'container-hug-bottom-right',
              })}
            </th>
          </tr>
        </thead>

        <tbody className={styles.trTdFC} style={tableData} >
          {/* This first row of data in the table is the shopper's data. */}
          <tr>
            <td>{orderData.shortname}</td>
        { isSingular
          ? null
          : <td>{orderData.unitQty}</td>
        }
            <td style={textAlignRight}>
              {orderData.wantd}
            </td>
            <td>
              {orderData.rangeNoteWide}
            </td>
            <td style={textAlignRight}>
             <div className="oneline-container-right">
              {orderData.outlay}
             </div>
            </td>
          </tr>

          {/* These next rows of 'othData' are for the other shoppers. */}
          <OthersOrdersTable
            if_shopper_is_circle_admin = { if_shopper_is_circle_admin }
            trip = { trip } 
            sku = { sku }
            othData = { othData }
            skuPrice = { skuPrice }
            headings = { headings }
            actualWeight = { actualWeight }
          />
        </tbody>
      </Table>
    : null
  }
      
      <HeadingBuilder
        headingText    = {t('ordersList.verticalTableButton.labelClose')}
        // Minimize 'Order Item' details
        buttonAction   = {handleClick}
        goButtonText   = {Constants.GET_ICON_RT_ARROW}

        tippyAlertText = {t('ordersList.verticalTableButton.tippyContent')}
        tippyText      = {Constants.DOT}
      />
    </>
    )
  } else {
    return (
      <HeadingBuilder
        Size = 'h3'
        headingText = {t('global.notSignedInMessage')}
        // Not Authorized - Please Sign in or Sign up
      />
    )
  }
}
export default OrderItemTable